import { render, staticRenderFns } from "./RegistratiesIndex.vue?vue&type=template&id=6401c51a&scoped=true&"
import script from "./RegistratiesIndex.vue?vue&type=script&lang=js&"
export * from "./RegistratiesIndex.vue?vue&type=script&lang=js&"
import style0 from "./RegistratiesIndex.vue?vue&type=style&index=0&id=6401c51a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401c51a",
  null
  
)

export default component.exports